import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "chat",
  id: "chat"
}
const _hoisted_2 = { class: "mainMessage" }
const _hoisted_3 = { class: "message" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { id: "bottomAnchor" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Feedback = _resolveComponent("Feedback")!
  const _component_Message = _resolveComponent("Message")!
  const _component_SendMessage = _resolveComponent("SendMessage")!

  return (_ctx.feedback)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Feedback, { feedback: _ctx.feedback }, null, 8, ["feedback"]),
            (_ctx.feedback.messages)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.feedback.messages, (message, index) => {
                    return (_openBlock(), _createBlock(_component_Message, {
                      key: index,
                      message: message
                    }, null, 8, ["message"]))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            _hoisted_5
          ])
        ]),
        (!_ctx.feedbackCompleted)
          ? (_openBlock(), _createBlock(_component_SendMessage, {
              key: 0,
              onMessageSent: _ctx.getFeedback
            }, null, 8, ["onMessageSent"]))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}